import type {Middleware} from '@floating-ui/vue'
import {measureNaturalFloatingSize} from './measureNaturalFloatingSize'

/**
 * Patches floating rects to the unconstrained content size so subsequent
 * middleware (`flip`, `size`) run `detectOverflow` against real content, not
 * the previous frame's maxHeight clamp.
 *
 * After `size()` has applied and reset rects, this becomes a no-op so final
 * coordinates use the real (possibly constrained) DOM size.

 *
 * @see https://floating-ui.com/docs/detectOverflow
 * @see https://floating-ui.com/docs/size#using-with-flip
 */
export function applyNaturalFloatingSize(keepContentMaxHeight = false): Middleware {
  return {
    name: 'applyNaturalFloatingSize',
    fn(state) {
      // size() merges into middlewareData before requesting a rects reset.
      // Once it has run in this computePosition cycle, keep real DOM rects.
      if (state.middlewareData.size) {
        return {}
      }

      const {width, height} = measureNaturalFloatingSize(
        state.elements.floating,
        keepContentMaxHeight,
      )
      state.rects.floating.width = width
      state.rects.floating.height = height

      return {
        data: {
          width,
          height,
        },
      }
    },
  }
}
